import EcocardioDatiList from "./pages/EcocardioDatiList.vue";

export default {
    EcocardioDatiList,
};
